import { fromJS } from "immutable";
import { TOAST_MSJ,LOG_USER, LOGOUT_USER, SEND_USER_MSJ, TOKEN_VENCIDO, CHK_USER,CAMBIA_HOTEL_DEF } from "../actions/constants";
import moment from 'moment'

const initialHeader = {
	user: null,
	id_hotel_def:4,
	msj: {
		tipo: 1,
		contenido: "",
	},
	menu:[],
	unidades:[],
	allowed_dest:[],
	contador: 0,
	contador_msj: 0,
	logueado:false,
	toast_msj:{
		cont:"",
		tipo:"success",
		time:0
	}
};

function extractAllowedDestinos(opciones){
	//console.log(opciones)
	return opciones.map(opcion=> opcion.sub_dest)
}

function toObject (array, key){
	console.log(array)
	return !array ?{}: array.reduce((obj, item) => {
		obj[item[key]] = item;
		return obj;
	}, {})
}

const usuario = (state = initialHeader, action) => {
	const estadoNuevo = Object.assign({}, state);
	const datos = fromJS(estadoNuevo);

	switch (action.type) {
		case TOAST_MSJ:
			//console.log(action.payload);
			const toastNew = datos.updateIn(["toast_msj"], (value) => action.payload);
			return toastNew.toJS();

		case LOG_USER:
			//console.log(action.payload);
			console.warn("LOG_USER",action.payload.u.hotel_def )
			const dests = extractAllowedDestinos(action.payload.menu)
			const loginNew = datos.updateIn(["user"], (value) => action.payload.u);
			const logueadoStateNew = loginNew.updateIn(["logueado"], (value) => true);
			const menuStateNew = logueadoStateNew.updateIn(["menu"], (value) => action.payload.menu);
			const unidadesStateNew = menuStateNew.updateIn(["unidades"], (value) => toObject(action.payload.unidades, 'id'));
			const destsStateNew = unidadesStateNew.updateIn(["allowed_dest"], (value) => dests);
			const hotelStateNew = destsStateNew.updateIn(["id_hotel_def"], (value) => action.payload.u.hotel_def);
			const countNew = hotelStateNew.updateIn(["contador"], (value) => moment().unix());
			return countNew.toJS();

		case LOGOUT_USER:
			const logoutNew = datos.updateIn(["user"], (value) => null);
			const deslogueadoStateNew = logoutNew.updateIn(["logueado"], (value) => false);
			const deslogMsjNew = deslogueadoStateNew.updateIn(["msj"], (value) => "");
			const deslogMsjTipoNew = deslogMsjNew.updateIn(["msj_tipo"], (value) => "");
			const countLogoutNew = deslogMsjTipoNew.updateIn(["contador"], (value) => moment().unix());
			return countLogoutNew.toJS();

		case SEND_USER_MSJ:
			const msjNew = datos.updateIn(["msj"], (value) => action.msj);
			const msjTipoNew = msjNew.updateIn(["msj_tipo"], (value) => action.msj_tipo);
			const msjCountNew = msjTipoNew.updateIn(["contador_msj"], (value) => moment().unix());
			return msjCountNew.toJS();

		case TOKEN_VENCIDO:
			const vencidoNew = datos.updateIn(["user"], (value) => null);
			const vencidoStateNew = vencidoNew.updateIn(["logueado"], (value) => false);
			const countVencidoNew = vencidoStateNew.updateIn(["contador"], (value) => moment().unix());
			return countVencidoNew.toJS();
		
		case CHK_USER:
			if(action.payload){
				console.warn("CHK_USER",action.payload.u.hotel_def )
				const u ={
					id:action.payload.u.id,
					nombre:action.payload.u.nombre,
					apellido:action.payload.u.apellido,
					tipo:action.payload.u.tipo,
					rol:action.payload.u.rol
				}
				//console.log(u)
				const dests = extractAllowedDestinos(action.payload.menu)

				const traeUserNew = datos.updateIn(["user"], (value) =>u);
				const menuCheckStateNew = traeUserNew.updateIn(["menu"], (value) => action.payload.menu);
				const unidadesCheckStateNew = menuCheckStateNew.updateIn(["unidades"], (value) => toObject(action.payload.unidades, 'id'));
				const destsCheckStateNew = unidadesCheckStateNew.updateIn(["allowed_dest"], (value) =>dests);
				const hotelDefNew = destsCheckStateNew.updateIn(["id_hotel_def"], (value) => action.payload.u.hotel_def ? action.payload.u.hotel_def : 4);
				const chkUserNew = hotelDefNew.updateIn(["contador"], (value) => moment().unix());
				return chkUserNew.toJS();
			}else{
				const chkUserNew = datos.updateIn(["contador"], (value) => moment().unix());
				return chkUserNew.toJS();
			}
		
		case CAMBIA_HOTEL_DEF:
			const cambiaHotelDefNew = datos.updateIn(["id_hotel_def"], (value) => action.payload);
			return cambiaHotelDefNew.toJS();
		default:
			return state;
	}
};

export default usuario;
